import React from 'react';
import { Box, COLORS } from '@podiumhq/design-system';
import ReviewInviteCard from './ReviewInviteCard';
import ReviewCard from './ReviewCard';
import { motion, AnimatePresence } from 'framer-motion';

const BusinessInfoAnimations = ({
  businessName,
  showReview,
  reviewContent,
}) => {
  return (
    <Box
      w="100%"
      h="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        h="595px"
        w="316px"
        background={COLORS.silver.lightest}
        borderRadius="24px"
        p="48px 32px"
        display="flex"
        flexDirection="column"
      >
        <AnimatePresence>
          {showReview ? (
            <motion.div
              key="review-card"
              style={{ width: '100%', height: '100%' }}
              initial={{ opacity: 0, y: 50, display: 'none' }}
              animate={{ opacity: 1, y: 0, display: 'block' }}
              exit={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.7 }}
            >
              <ReviewCard {...reviewContent} businessName={businessName} />
            </motion.div>
          ) : (
            <motion.div
              key="review-invite-card"
              style={{ width: '100%', minHeight: 500 }}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{
                opacity: 0,
                transition: { delay: 0.5 },
              }}
              transition={{ ease: 'linear', duration: 0.5 }}
            >
              <ReviewInviteCard businessName={businessName} />
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </Box>
  );
};

export default BusinessInfoAnimations;
